import { Icon } from "@components/icon";
import { LinkWithConfirm } from "@components/link_with_confirm/link_with_confirm";
import * as types from "@root/types";
import { isEmpty } from "@services/helpers";
import cx from "classnames";
import React, { type FC } from "react";

interface ArtistExclusionListProps {
  artistExclusions: types.ArtistExclusion[];
}
const ArtistExclusionRow: FC<{ exclusion: types.ArtistExclusion }> = ({
  exclusion,
}) => {
  const deleteLink = (
    <LinkWithConfirm
      className="delete_link"
      confirmMessage="Are you sure you want to delete this exclusion?"
      href={`/admin/exclusion/${exclusion.id}/delete`}
      title={`Delete exclusion for ${exclusion.name}`}
    >
      <Icon name="bin2" />
    </LinkWithConfirm>
  );

  return (
    <tr>
      <td className="name" scope="row">
        {exclusion.name}
      </td>
      <td
        className={cx("case_insensitive", "table-cell--centered")}
        scope="row"
      >
        {exclusion.caseInsensitive ? (
          <Icon ariaLabel="Y" name="checkmark" />
        ) : null}
      </td>
      <td className="ctrls">{deleteLink}</td>
      <td className="matches">
        {exclusion.matches.map((match) => (
          <span key={match} className="exclusions--artist-match">
            {match}
          </span>
        ))}
      </td>
    </tr>
  );
};
const ArtistExclusionList: FC<ArtistExclusionListProps> = ({
  artistExclusions,
}) => {
  return (
    <table className={cx("exclusions", "striped")}>
      <thead>
        <tr>
          <th className="name" scope="col">
            Name
          </th>
          <th className="case_insensitive" scope="col">
            Ignore Case?
          </th>
          <th className="ctrls" scope="col"></th>
          <th className="matches" scope="col">
            Matches
          </th>
        </tr>
      </thead>
      <tbody>
        {isEmpty(artistExclusions) ? (
          <tr>
            <td colSpan={4}>No exclusions have been defined yet.</td>
          </tr>
        ) : null}
        {artistExclusions.map((exclusion) => (
          <ArtistExclusionRow exclusion={exclusion} key={exclusion.name} />
        ))}
      </tbody>
    </table>
  );
};

export { ArtistExclusionList };
